module.exports = __webpack_public_path__ + "img/cardFrame_S_2.c161de51.png";